module.exports = __webpack_public_path__ + "static/img/preview-06.7c5a176f.webp";